import React, { useEffect, useState } from "react";
import "./PaymentMethodsModal.css";

const paymentOptions = [{ id: "cybersource", label: "CyberSource" }];

const PaymentMethodsModal = ({
  show,
  onClose,
  onSave,
  selectedPaymentMethod = paymentOptions[0].id,
}) => {
  const [selectedPayment, setSelectedPayment] = useState(selectedPaymentMethod);

  useEffect(() => {
    if (!show) {
      return undefined;
    }

    setSelectedPayment(selectedPaymentMethod);

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [show, onClose, selectedPaymentMethod]);

  if (!show) {
    return null;
  }

  const handleSave = () => {
    onSave?.(selectedPayment);
    onClose();
  };

  return (
    <div className="payment-methods-backdrop" onClick={onClose}>
      <div
        className="payment-methods-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="payment-methods-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="payment-methods-header">
          <h2 id="payment-methods-modal-title">Change Payment</h2>
          <button
            type="button"
            className="payment-methods-close"
            aria-label="Close payment methods modal"
            onClick={onClose}
          >
            <i className="ph ph-x" />
          </button>
        </div>

        <div className="payment-methods-body">
          {paymentOptions.map((option) => (
            <label className="payment-methods-option" key={option.id}>
              <span>{option.label}</span>
              <input
                type="radio"
                name="accountPaymentMethod"
                value={option.id}
                checked={selectedPayment === option.id}
                onChange={() => setSelectedPayment(option.id)}
              />
            </label>
          ))}

          <div className="payment-methods-actions">
            <button
              type="button"
              className="payment-methods-cancel"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="payment-methods-save"
              onClick={handleSave}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodsModal;
